import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Dialog } from "primereact/dialog";
import Langs from "../../../app/lang/langs";
import { InputField } from "../../inputs/InputField";
import { DynamicButton } from "../../buttons/DynamicButton";
import { Row } from "primereact/row";
import { Col } from "react-bootstrap";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import NewsReadCheckbox from "./NewsReadCheckbox";


export default function NewsModal(props) {

    const isMobile = useSelector((state) => state.settings.isMobile)
    const newsList = useSelector((state) => state.dashboard.news)
    const [updatedItem, setUpdatedItem] = useState(props.selectedNews)

    const mobile = isMobile === 2

    // `props.selectedNews` is a snapshot taken when the row was clicked, so read
    // the acknowledgement state from the store to hide the hint once confirmed.
    const isAcknowledged = Boolean(
        newsList?.find(news => news.id === props.selectedNews?.id)?.seen
    )

    const handleFieldChange = (value, field) => {
        setUpdatedItem(prev => ({
            ...prev,
            [field.key]: value
        }))
    }

    // Viewing a news item no longer marks it as read — the collab has to tick
    // the acknowledgement checkbox below explicitly.
    useEffect(() => {
        setUpdatedItem({
            ...props.selectedNews
        })
    }, [props.selectedNews])

    const visibleFields = [
        { key: "title", type: "string", disabled: true },
        { key: "message", type: "text", disabled: true, auto: true },
        { key: "created_by", type: "string", disabled: true },
        { key: "created_at", type: "date:time", disabled: true },
    ]

    const handleSave = async () => {

    }

    const footer = () => {
        if (JSON.stringify(props.selectedNews) != JSON.stringify(updatedItem))
            return <Row className="d-flex justify-content-center" >
                <Col lg={2} xs={mobile ? 8 : 2}>
                    <DynamicButton
                        onClick={handleSave}
                        className='me-auto'
                        title={<Langs str="Save" />}
                        active={true}
                        color="green"
                    />
                </Col>
            </Row>
    }

    return (
        <>
            <Dialog
                visible={props.selectedNews}
                className={mobile ? "news-modal-mobile" : ""}
                style={{
                    width: mobile ? "100%" : "50%",
                    maxHeight: mobile ? "85vh" : undefined,
                    borderRadius: mobile ? "16px 16px 0 0" : "18px",
                    overflow: "hidden",
                    boxShadow: "0 8px 32px rgba(255, 144, 21, 0.10), 0 2px 12px rgba(0, 0, 0, 0.08)",
                    border: mobile ? "none" : "1px solid rgba(255, 144, 21, 0.12)",
                    backdropFilter: "blur(16px)",
                    WebkitBackdropFilter: "blur(16px)",
                    background: "rgba(255, 255, 255, 0.88)",
                    ...(mobile ? { margin: 0, bottom: 0, position: "fixed", left: 0, right: 0, top: "auto" } : {}),
                }}
                contentStyle={{
                    padding: mobile ? "16px" : "24px 28px",
                    background: "transparent",
                    overflow: mobile ? "auto" : undefined,
                }}
                headerStyle={{
                    padding: mobile ? "16px 16px 10px" : "20px 28px 12px",
                    background: "linear-gradient(135deg, rgba(255, 144, 21, 0.06) 0%, rgba(255, 193, 0, 0.04) 100%)",
                    borderBottom: "1px solid rgba(255, 144, 21, 0.10)",
                    fontWeight: 600,
                    letterSpacing: "-0.02em",
                    color: "#2d2a26",
                    fontSize: "1.1rem",
                }}
                onHide={() => {
                    props.onHide()
                }}
                header={<Langs str="Actualité" />}
                draggable={false}
                dismissableMask={false}
                footer={footer}
            >
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: mobile ? "12px" : "16px",
                    animation: mobile
                        ? "newsModalSlideUp 300ms cubic-bezier(0.4, 0, 0.2, 1) both"
                        : "newsViewModalFadeIn 280ms cubic-bezier(0.4, 0, 0.2, 1) both",
                }}>
                    {props.selectedNews && props.selectedNews.id && !isAcknowledged && (
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.75,
                                color: "#b06000",
                                // Stays pinned to the top of the content while the
                                // message scrolls, so the instruction never scrolls away.
                                position: "sticky",
                                top: mobile ? "-16px" : "-24px",
                                zIndex: 2,
                                mx: mobile ? "-16px" : "-28px",
                                px: mobile ? "16px" : "28px",
                                py: 1,
                                background: "rgba(255, 250, 242, 0.94)",
                                backdropFilter: "blur(8px)",
                                WebkitBackdropFilter: "blur(8px)",
                                borderBottom: "1px solid rgba(255, 144, 21, 0.16)",
                            }}
                        >
                            <KeyboardDoubleArrowDownIcon sx={{ fontSize: 18 }} />
                            <Typography sx={{ fontSize: "0.78rem", fontWeight: 500 }}>
                                <Langs str="NEWS_SCROLL_DOWN_TO_CONFIRM" />
                            </Typography>
                        </Box>
                    )}
                    {visibleFields.map(field => <InputField field={field}
                        onChange={(e) => handleFieldChange(e, field)}
                        value={updatedItem && updatedItem[field.key]} />
                    )}
                    {props.selectedNews && props.selectedNews.id && (
                        <NewsReadCheckbox news={props.selectedNews} />
                    )}
                </div>
            </Dialog>
            <style>{`
                @keyframes newsViewModalFadeIn {
                    from { opacity: 0; transform: translateY(8px); }
                    to   { opacity: 1; transform: translateY(0); }
                }
                @keyframes newsModalSlideUp {
                    from { opacity: 0; transform: translateY(40px); }
                    to   { opacity: 1; transform: translateY(0); }
                }
                .news-modal-mobile input,
                .news-modal-mobile textarea {
                    font-size: 16px !important;
                }
                .news-modal-mobile .p-dialog-header-icons .p-dialog-header-icon {
                    width: 44px !important;
                    height: 44px !important;
                    min-width: 44px;
                    min-height: 44px;
                }
                .news-modal-mobile + .p-dialog-mask,
                .news-modal-mobile.p-dialog + .p-component-overlay {
                    backdrop-filter: blur(6px);
                    -webkit-backdrop-filter: blur(6px);
                }
            `}</style>
        </>
    )
}
